import React from 'react';
import { API } from 'aws-amplify';
import { toast } from 'react-toastify';

const useTenDayTimeline = (_appInstId, _questionId) => {
    const [id] = React.useState(_appInstId);
    const [questionId] = React.useState(_questionId);

    const [doingAjax, setDoingAjax] = React.useState(false);

    const updateTenDayTimeline = async (newDate) => {
        setDoingAjax(true);
        let successful = true;

        let _value;
        if (typeof newDate?.toISOString === 'function') {
            _value = newDate.toISOString();
        } else if (/^(\d\d\d\d)-(\d\d)-(\d\d) (\d\d):(\d\d):(\d\d)$/.test(newDate)) {
            _value = newDate;
        } else {
            _value = '';
        }

        try {
            await API.post('ShipyardAPI', `/admin/application_instance/${id}/tenday_timeline`, {
                body: {
                    questionId: questionId,
                    value: _value,
                },
            });

            toast.success('Ten Day Timeline successfully updated.');
        } catch (e) {
            toast.error('Error occurred updating Ten Day Timeline.');

            successful = false;
        } finally {
            setDoingAjax(false);
        }

        return { succeeded: successful, newDate: _value };
    };

    return { doingAjax, updateTenDayTimeline };
};

export default useTenDayTimeline;
